import * as types from '../types'
import { statusChange } from '@/utils';
const init = {
    config: {
        // mainTitle: '白条笔笔攒',
        // subTitle: '做任务打白条,攒够领奖励',
        // img: 'https://img11.360buyimg.com/imagetools/jfs/t1/162420/27/14369/75549/6059c398E9f32367a/1bb4dc199ac17b17.png'
    },
    end: false,
    pageNo: 1,
    list: [
        
    ]

}
const list = (state = init, action) => {
    switch (action.type) {
        case types.LIST_HANDLE: {
            const newState = {...state}
            const {
                data: {
                    list,
                    pageBean,
                    timer
                }
            } = action;
            const time = timer || new Date().getTime();
            newState.list = newState.list.concat(list);
            newState.pageNo++;
            newState.end = pageBean.end
            //  newState.list = [];
            //  newState.end = true;
            newState.list.map((it, idx) => {
                //it.status = 0;
                // it.frozenTime = 1
                // it.rewardDeadline = 1
                //it.accrue = 100
                //使用前端状态
                it.page = 'list';
                const { 
                    mask, 
                    listText, 
                    listSty, 
                    listCls, 
                    rewardStartTime,
                    rewardEndTime,
                    listDayText,
                    showTime
                } = statusChange(it, time);
                //领奖开始时间
                it.rewardStartTime = rewardStartTime;
                //领奖结束时间
                it.rewardEndTime = rewardEndTime;
                
                              
                const rate = ((it.accrue / it.reachNumber)*100).toFixed(2);
                it.rate = rate > 100?Number(100).toFixed(2): rate;
                it.listDayText = listDayText;
                it.realStatus = mask;
                it.btnText = listText;
                it.btnSty = listSty; 
                it.btnCls = listCls;
                it.showTime = showTime;
            })
            return newState;
        };
        case types.TASK_HANDLE: {
            const { channelCode, taskCode } = action.data;
            const newState = {...state}
            newState.list.map(it => {
                if(it.taskCode === taskCode) {
                    it.status = 1;
                    const rate = ((it.accrue / it.reachNumber)*100).toFixed(2);
                    it.rate = rate > 100?Number(100).toFixed(2): rate;
                    it.realStatus = 'ac1';
                    it.btnText = '继续完成';
                    it.btnSty = '';
                    it.btnCls = 'rwlist|an-jxwc';
                }
            })
            window.locationTo({
                url: '/home',
                params: {
                    channelCode,
                    taskCode
                }
            })
            return newState;
        };
        case types.LIST_BASE_HANDLE: {
            const newState = {...state}
            const { data } = action;
            data.map(it => {
                if(it.templateInstanceKey === 'list_info'){
                    newState.config = it.templateData.elementList[0];
                }
            })
            
            return newState;
        };
        default:
            return state;
    }
}


export default list;
